import { Breadcrumb, BreadcrumbItem } from "@carbon/react";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";

import { BackButtonWithCondition } from "src/components/Buttons";
import Loading from "src/components/DataStates/Loading.tsx";
import InlineError from "src/components/Errors/InlineError.tsx";
import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { SelectedTabType } from "src/components/TabbedView/useTabNavigation.ts";
import { DynamicViewRenderer } from "src/dynamic-view-renderer/DynamicViewRenderer.tsx";
import { useViewDefinition } from "src/dynamic-view-renderer/Views/useViewDefinition";
import { useGetBlacklistElementById } from "src/graphql/anti-fraud/queries/blacklists/GetBlacklistElementByIdQuery.ts";
import { useT } from "src/internationalization";
import { mapToPropertyValue } from "src/mappers/property.mappers";

const BlacklistDetailsPage: React.FC = () => {
  const t = useT();
  const { id } = useParams<{ id: string }>();

  const { data: blacklistElement, error, loading } = useGetBlacklistElementById({ id });

  const viewDefinition = useViewDefinition("BlacklistDetailsView");
  const viewConfiguration = viewDefinition?.view;

  const [_selectedTab, setSelectedTab] = useState<SelectedTabType | undefined>();

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <InlineError message={error.message} />;
  }

  if (!blacklistElement) {
    // a traduire page.blacklists.detail.notFound
    return <InlineError message={"error"} />;
  }

  const propertyValue = blacklistElement.properties.map((p) => mapToPropertyValue(p));
  const blacklistName = blacklistElement.blacklist.name;

  //t("page.blacklists.breadcrumb")

  return (
    <PageStack>
      <Breadcrumb noTrailingSlash={true}>
        <BreadcrumbItem>
          <Link to="/blacklists">{"blacklists"}</Link>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage={true}>{blacklistName}</BreadcrumbItem>
      </Breadcrumb>

      <div className="flex flex-col">
        <div className="flex items-center">
          <BackButtonWithCondition className="!py-2" />

          <div className="flex-1 flex items-center justify-between">
            <PageHeader>{blacklistName}</PageHeader>
          </div>
        </div>
      </div>

      {viewConfiguration ? (
        <DynamicViewRenderer
          viewConfiguration={viewConfiguration}
          data={{
            widgetsData: {
              basic: {
                item: {
                  propertyValues: propertyValue,
                  type: "blacklist",
                  code: blacklistElement.typeCode,
                },
              },
            },
          }}
          pathPrefix="/blacklist/:blacklistCode/:id"
          onNavigate={setSelectedTab}
        />
      ) : (
        <InlineError message={t("general.view.caseType.missing.error")} />
      )}
    </PageStack>
  );
};

export default BlacklistDetailsPage;
